<template>
  <div>
    <div>
      <basicHeader title="Edit Tax" @backPress="$router.push(`/setup/tax`)" />
    </div>
    <ValidationObserver ref="observer">
      <vx-card class="form-padding">
        <div class="vx-row">
          <div class="vx-col md:w-1/2 w-full">
            <ValidationProvider
              rules="required"
              v-slot="{ errors }"
              :name="$t('setup.label.TaxCode')"
            >
              <vs-input
                :label="$t('setup.label.TaxCode')"
                v-model="taxCode"
                class="w-full mb-2 starlabel"
              />
              <span class="validate-error" style="color: red">{{
                errors[0]
              }}</span>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-1/2 w-full">
            <div class="dropdown-with-label">
              <small class="date-label"
                >{{ $t("setup.label.GroupType")
                }}<span class="required"> *</span></small
              >
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('setup.label.GroupType')"
              >
                <v-select
                  label="mCodeValue"
                  :reduce="(obj) => obj.mCodeValue"
                  :options="taxTemplate.taxGroupData"
                  v-model="groupType"
                  :placeholder="$t('placeholder.label.SelectOne')"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  class="min-w-200 w-full"
                >
                  <template v-slot:option="option">{{
                    option.mCodeValue
                  }}</template>
                </v-select>
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
          </div>
        </div>
        <div class="vx-row mt-4">
          <div class="vx-col md:w-1/2 w-full">
            <div class="dropdown-with-label">
              <small class="date-label"
                >{{ $t("setup.label.Type")
                }}<span class="required"> *</span></small
              >
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('setup.label.Type')"
              >
                <v-select
                  label="mCodeValue"
                  :reduce="(obj) => obj.mCodeValue"
                  :options="taxTemplate.taxTypeData"
                  v-model="type"
                  :placeholder="$t('placeholder.label.SelectOne')"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  class="min-w-200 w-full"
                >
                  <template v-slot:option="option">{{
                    option.mCodeValue
                  }}</template>
                </v-select>
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-col md:w-1/2 w-full">
            <ValidationProvider rules="" v-slot="{ errors }" name="group code">
              <vs-input
                :label="$t('setup.label.GroupCode')"
                v-model="groupCode"
                class="w-full mb-2"
              />
              <span class="validate-error" style="color: red">{{
                errors[0]
              }}</span>
            </ValidationProvider>
          </div>
        </div>
        <div class="vx-row mt-4">
          <div class="vx-col md:w-1/2 w-full">
            <div class="dropdown-with-label">
              <small class="date-label">{{
                $t("setup.label.StartDate")
              }}</small>
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('setup.label.StartDate')"
              >
                <datepicker
                  :placeholder="$t('placeholder.label.SelectDate')"
                  v-model="startDate"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  class="min-w-200 w-full"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-col md:w-1/2 w-full">
            <div class="dropdown-with-label">
              <small class="date-label">{{ $t("setup.label.EndDate") }}</small>
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('setup.label.EndDate')"
              >
                <datepicker
                  :placeholder="$t('placeholder.label.SelectDate')"
                  v-model="endDate"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  class="min-w-200 w-full"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
          </div>
        </div>
        <div class="center">
          <span class="ml-3 mr-4">
            <vs-button
              type="border"
              style="width: 190px; margin-top: 20px; margin-bottom: 10px"
              @click="$router.push(`/setup/tax`)"
              >{{ $t("setup.label.Cancel") }}</vs-button
            >
          </span>
          <span class="ml-1 mr-2">
            <vs-button style="width: 190px" @click="handleUpdateTax">{{
              $t("setup.label.Submit")
            }}</vs-button>
          </span>
        </div>
      </vx-card>
    </ValidationObserver>
    <validation-popup
      :errorMessage="errorMessage"
      :warningPopup="warningPopup"
      :warningText="warningText"
      @closeWarning="warningPopup = false"
    ></validation-popup>
  </div>
</template>

<script>
import basicHeader from "@/components/common/basicHeader";
import Datepicker from "vuejs-datepicker";
import vSelect from "vue-select";
import moment from "moment";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { mapState } from "vuex";
export default {
  components: {
    basicHeader,
    Datepicker,
    "v-select": vSelect,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      warningPopup: false,
      warningText: "",
      errorMessage: "",
      taxCode: "",
      groupType: "",
      startDate: "",
      endDate: "",
      type: "",
      groupCode: "",
      baseTaxCode: "",
      taxData: {},
      rateTypes: ["Percentage", "Flat"],
    };
  },
  computed: {
    ...mapState({
      taxTemplate: (state) => state.taxmap.taxTemplate,
      addressData: (state) => state.addressMaster.addressData,
    }),
    countryList() {
      const uniqueData = {};
      this.addressData.forEach((item) => {
        if (!uniqueData[item.countryId]) {
          uniqueData[item.countryId] = {
            countryName: item.countryName,
            countryId: item.countryId,
          };
        }
      });
      return Object.values(uniqueData);
    },
    stateList() {
      const uniqueStates = {};
      this.addressData.forEach((item) => {
        if (item.stateId && !uniqueStates[item.stateId]) {
          uniqueStates[item.stateId] = {
            stateName: item.stateName,
            stateId: item.stateId,
            countryId: item.countryId,
          };
        }
      });
      return Object.values(uniqueStates);
    },
    districtList() {
      const uniqueDistricts = {};
      this.addressData.forEach((item) => {
        if (item.districtId && !uniqueDistricts[item.districtId]) {
          uniqueDistricts[item.districtId] = {
            districtName: item.districtName,
            districtId: item.districtId,
            stateId: item.stateId,
          };
        }
      });
      return Object.values(uniqueDistricts);
    },
  },
  methods: {
    async handleUpdateTax() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;

      let payload = {
        taxId: this.$route.params.taxId,
        taxCode: this.taxCode,
        groupType: this.groupType,
        groupCode: this.groupCode,
        type: this.type,
        startDate:
          moment(this.startDate).format("YYYY-MM-DD") || this.startDate,
        endDate: moment(this.endDate).format("YYYY-MM-DD") || this.endDate,
        dateFormat: "yyyy-MM-dd",
        locale: "en",
        baseTaxcode: this.baseTaxCode,
      };
      try {
        await this.$store.dispatch("taxmap/updateTaxAction", {
          data: payload,
          id: this.$route.params.taxId,
        });
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Tax Master Updated Successfully!",
          type: "success",
        });
        this.$router.push(`/setup/tax`);
      } catch (error) {
        const errorMessage = String(error).replace(/^Error:\s*/, "");
        this.$swal({
          title: "Error",
          icon: "error",
          html: `<div style="text-align: center;">${errorMessage}</div>`,
          type: "error",
        });
      }
    },
  },
  async mounted() {
    await this.$store.dispatch("taxmap/fetchTaxTemplate");
    await this.$store.dispatch("addressMaster/fetchAddressData");
    this.taxData = await this.$store.dispatch(
      "taxmap/fetchTaxInfoById",
      this.$route.params.taxId
    );
    this.taxCode = this.taxData.data.taxCode;
    this.groupType = this.taxData.data.groupType;
    this.startDate = this.taxData.data.startDate;
    this.endDate = this.taxData.data.enddate;
    this.type = this.taxData.data.type;
    this.groupCode = this.taxData.data.groupCode;
    this.baseTaxCode = this.taxData.data.baseTaxcode;
  },
};
</script>
